import { useState } from "react";
import { Button } from "../components/Button";
import { RoomCodeInput } from "../components/RoomCodeInput";
import { ScreenShell } from "../components/ScreenShell";
import { useUiText } from "../i18n/useUiText";
import { ROOM_CODE_LENGTH } from "../../../../packages/session-code/src";
import { useAppStore } from "../state/useAppStore";

export function JoinScreen() {
  const t = useUiText();
  const [code, setCode] = useState("");
  const isCreating = useAppStore((state) => state.isCreating);
  const sessionError = useAppStore((state) => state.sessionError);
  const goHome = useAppStore((state) => state.goHome);
  const joinSession = useAppStore((state) => state.joinSession);

  const submit = (value: string) => {
    if (value.length === ROOM_CODE_LENGTH && !isCreating) {
      void joinSession(value);
    }
  };

  return (
    <ScreenShell
      backLabel={t("common.home")}
      footer={
        <Button
          disabled={isCreating || code.length < ROOM_CODE_LENGTH}
          onClick={() => submit(code)}
          wide
        >
          {t("join.submit")}
        </Button>
      }
      onBack={goHome}
    >
      <div className="narrow-column">
        <header className="screen-heading screen-heading--centered">
          <h1>{t("join.title")}</h1>
          <p>{t("join.prompt")}</p>
        </header>

        <div className="setup-form join-form">
          <div className="text-field text-field--centered">
            <span className="field-label">{t("join.codeLabel")}</span>
            <RoomCodeInput
              disabled={isCreating}
              label={t("join.codeLabel")}
              onChange={setCode}
              onComplete={submit}
            />
          </div>

          {sessionError ? (
            <p className="inline-error" role="alert">
              {t("error.join")}
            </p>
          ) : null}
        </div>
      </div>
    </ScreenShell>
  );
}
